/* eslint-disable no-undef */
export default {
	name: "manage-depot-products-modal",
	props: ["heading", "modalId", "showModal", "depotId", "isAdditionalProducts"],
	emits: ["okClicked"],
	data() {
		return {
			depotProducts: [],
			products: [],
			depots: [],
			selectedDepotId: null,
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			canSaveProducts: true,
			effectiveDate: new Date(),
			initialiseDate: true,
			// effectiveDate: null,
			// initialiseDate: false,
			depotErrorMessage: null,
			effectiveDateErrorMessage: null,
		};
	},
	methods: {
		getProducts() {
			this.loading = true;
			let request = {
				allowCollection: true,
				allowDelivery: false,
				isActive: true
			};
			productService.getProducts(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.products = successResponse.data.result;
						this.products = dataTableHelper.castFieldValues(this.products);
						// filter out additional services if not required by product type ids 3, 4 and 5
						// if(!this.isAdditionalProducts){
						// 	this.products = this.products.filter(product => product.productTypeId !== 3 && product.productTypeId !== 4 && product.productTypeId !== 5);
						// }
						// else{
						// 	this.products = this.products.filter(product => product.productTypeId === 3 || product.productTypeId === 4 || product.productTypeId === 5);
						// }
						for(var i = 0; i < this.products.length; i++){
							this.products[i].isSelected = false;
							this.products[i].price = null;
							this.products[i].transportFactor = null;
							this.products[i].depotProductPriceId = 0;
							this.products[i].errorMessagePrice = null;
							this.products[i].errorMessageTransportFactor = null;
						}
						if(this.selectedDepotId !== null && this.selectedDepotId > 0) {
							if(!this.isAdditionalProducts) {
								this.getDepotProducts();
							}
							else{
								this.getDepotAdditionalServicesAndProducts();
							}
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDepotAdditionalServicesAndProducts(){
			let request = {
				depotId: this.selectedDepotId,
				pageNum: 1,
				pageSize: 500,
				isActive: true
			};
			orderService.getDepotAdditionalServicesAndProductsPrices(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depotProducts = successResponse.data.result;
						this.depotProducts = dataTableHelper.castFieldValues(this.depotProducts);
						for(var i = 0; i < this.products.length; i++){
							this.products[i].isSelected = false;
							this.products[i].price = null;
							this.products[i].transportFactor = null;
							this.products[i].depotProductPriceId = 0;
							this.products[i].errorMessagePrice = null;
							this.products[i].errorMessageTransportFactor = null;
							for(var j = 0; j < this.depotProducts.length; j++){
								this.products[i].isSelected = this.products[i].productId === this.depotProducts[j].productId;
								if(this.products[i].isSelected){
									this.products[i].price = this.depotProducts[j].price;
									this.products[i].transportFactor = this.depotProducts[j].transportFactor;
									this.products[i].depotProductPriceId = this.depotProducts[j].depotProductPriceId;
									break;
								}
							}
						}
						console.log("products", this.products);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDepotProducts() {
			let request = {
				depotId: this.selectedDepotId,
				pageNum: 1,
				pageSize: 500,
				isActive: true,
			};
			orderService.getDepotProductPrices(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depotProducts = successResponse.data.result;
						this.depotProducts = dataTableHelper.castFieldValues(this.depotProducts);
						for(var i = 0; i < this.products.length; i++){
							this.products[i].isSelected = false;
							this.products[i].price = null;
							this.products[i].transportFactor = null;
							this.products[i].depotProductPriceId = 0;
							this.products[i].errorMessagePrice = null;
							this.products[i].errorMessageTransportFactor = null;
							for(var j = 0; j < this.depotProducts.length; j++){
								this.products[i].isSelected = this.products[i].productId === this.depotProducts[j].productId;
								if(this.products[i].isSelected){
									this.products[i].price = this.depotProducts[j].price;
									this.products[i].transportFactor = this.depotProducts[j].transportFactor;
									this.products[i].depotProductPriceId = this.depotProducts[j].depotProductPriceId;
									break;
								}
							}
						}
						console.log("products", this.products);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDepots(){
			this.loading = true;
			let request = {
				isActive: true,
				provinceId: 0
			};
			systemService.getAllDepots(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depots = successResponse.data.result;
						this.depots = $.map(this.depots,
							function (obj) {
								obj.id = obj.id || obj.depotId;
								obj.text = obj.text || obj.name;
								return obj;
							});
						this.depots = dataTableHelper.castFieldValues(this.depots);
						//this.getDepotProducts();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onEffectiveDateSelect(date){
			this.effectiveDate = date;
			this.initialiseDate = false;
		},
		onProductSelect(product){
			console.log("product", product);
			if(product.price === null || product.price <= 0){
				product.errorMessagePrice = "Price is required";
				this.canSaveProducts = false;
			}
			else{
				this.canSaveProducts = true;
				product.errorMessagePrice = null;
			}
		},
		clearForm(){
			// Reset all product selections and values
			for(var i = 0; i < this.products.length; i++){
				this.products[i].isSelected = false;
				this.products[i].price = null;
				this.products[i].transportFactor = null;
				this.products[i].depotProductPriceId = 0;
				this.products[i].errorMessagePrice = null;
				this.products[i].errorMessageTransportFactor = null;
			}
			
			// Reset selected depot
			this.selectedDepotId = null;
			
			// Reset effective date
			this.effectiveDate = new Date();
			this.initialiseDate = true;
			
			// Clear error messages
			this.depotErrorMessage = null;
			this.effectiveDateErrorMessage = null;
		},
		clearMessageAlerts(){
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;
			
			// Clear the form after successful save
			if(this.showSuccessMessage || this.successMessage){
				this.clearForm();
			}
			
			this.$emit("okClicked", true);
		},
		onModalCloseClick() {
			//this.clearMessageAlerts();
			this.$emit("okClicked", true);
		},
		onDepotSelect(depot){
			this.selectedDepotId = depot.id;
			this.depotErrorMessage = null;
			if(this.selectedDepotId !== null && this.selectedDepotId > 0) {
				if(!this.isAdditionalProducts) {
					this.getDepotProducts();
				}
				else{
					this.getDepotAdditionalServicesAndProducts();
				}
			}
		},
		saveDepotProductPrices(){
			//save changes
			this.loading = true;
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;
			
			var depotProductPricesToSave = [];
			for(var i = 0; i < this.products.length; i++){
				if(this.products[i].isSelected){
					var depotProductPrice = {
						depotProductPriceId: this.products[i].depotProductPriceId,
						productId: this.products[i].productId,
						depotId: this.selectedDepotId,
						price: this.products[i].price,
						transportFactor: this.products[i].transportFactor === null ? 0 : this.products[i].transportFactor,
						isActive: true
					};
					
					if(this.products[i].depotProductPriceId > 0){
						depotProductPrice.isActive = true;
					}
					depotProductPricesToSave.push(depotProductPrice);
				}
			}
			
			let request = {
				effectiveDate: this.effectiveDate,
				depotId: this.selectedDepotId === null ? 0 : this.selectedDepotId,
				depotProductPricesToSave: depotProductPricesToSave
			};
			orderService.addOrUpdateDepotProductPrices(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.depotProductPriceAddOrUpdateValidationResponse.valuesAreValid){
							this.showSuccessMessage = true;
							this.successMessage = "Products assigned to depot successfully.";
						this.clearForm();
						}
						else{
							this.effectiveDateErrorMessage = successResponse.data.depotProductPriceAddOrUpdateValidationResponse.effectiveDateValidationResponse.message;
							this.depotErrorMessage = successResponse.data.depotProductPriceAddOrUpdateValidationResponse.depotValidationResponse.message;
						}
					}
					else{
						this.showErrorMessage = true;
						this.errorMessage = successResponse.data.message;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		validateDepotProductPrices(){
			this.canSaveProducts = true;
			for(var i = 0; i < this.products.length; i++){
				if(this.products[i].isSelected){
					if(this.products[i].price === null || this.products[i].price <= 0){
						this.products[i].errorMessagePrice = "Price is required";
						this.canSaveProducts = false;
					}
					else{
						this.products[i].errorMessagePrice = null;
					}
				}
			}
			if(this.canSaveProducts){
				this.saveDepotProductPrices();
			}
		}
	},
	mounted: function () {
        
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal("show");
					this.effectiveDate = new Date();
					this.initialiseDate = true;
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		depotId:{
			handler: function () {
				if(this.depotId !== null && this.depotId > 0){
					this.selectedDepotId = this.depotId;
				}
				this.getDepots();
				this.getProducts();
			},
			immediate: true,
			deep: true
		},
		isAdditionalProducts:{
			handler: function () {
				console.log("isAdditionalProducts", this.isAdditionalProducts);
			},
			immediate: true,
			deep: true
		}
	}
};
